<template>
  <div class="lg:!mx-0 flex">
    <Sidebar
      class="transition-all duration-150 shadow-[0_0_20px_rgba(0,0,0,0.2)]"
      :class="[showSidebar ? 'translate-x-0' : '-translate-x-[85%]']"
      :open="showSidebar"
      @mouseover="toggleShowSidebar(true, $event)"
      @mouseleave="toggleShowSidebar(false, $event)"
      @transitionend="sideBarToggled"
      @expanded="handleSidebarExpanded"
    />


    <Transition
      enter-active-class="animate__animated animate__fadeIn animate__fast"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
      mode="out-in"
    >
      <component
        :is="dashboardLayout"
        :key="selectedProject?.id"
      />
    </Transition>
  </div>
</template>

<script setup lang="ts">
import Sidebar from '@/components/layout/Sidebar.vue';
import ClientDashboard from '@/components/ProjectSelector/ClientDashboard.vue';
import HeadContractDashboard from '@/components/ProjectSelector/HeadContractDashboard.vue';
import SelfPerformDashboard from '@/components/ProjectSelector/SelfPerformDashboard.vue';
import { useNavStore } from '@/store/nav';
import { useProjectsStore } from '@/store/projects';
import { useUserStore } from '@/store/user';
import { computed, ref, useTemplateRef, watch } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps<{
  projectId?: string;
}>();

const router = useRouter();
const navStore = useNavStore();
const showSidebar = ref(router.currentRoute.value.params.projectId ? false : true);

// Ensure sidebar is shown and expanded when there's no projectId in the route
watch(() => router.currentRoute.value.params.projectId, (projectId) => {
  if(!projectId) {
    showSidebar.value = true;
    navStore.sidebarExpanded = true;
  }
}, { immediate: true });

const projectsStore = useProjectsStore();
const userStore = useUserStore();

const selectedProject = computed(() => {
  return projectsStore.project;
});

const applyHitbox = ref(true);

const sideBarToggled = () => {
  if(showSidebar.value) {
    applyHitbox.value = false;
  } else {
    applyHitbox.value = true;
  }
};

const toggleShowSidebar = (open: boolean, event?: MouseEvent) => {
  if(open) {
    showSidebar.value = true;
  } else if(!navStore.sidebarExpanded) {
    showSidebar.value = false;
  }
};

const handleSidebarExpanded = (expanded: boolean) => {
  navStore.sidebarExpanded = expanded;

  if(!expanded) {
    showSidebar.value = false;
  }
};

const dashboardLayout = computed(() => {
  if(userStore.isRole(['client_manager'], false)) {
    return ClientDashboard;
  }

  switch (selectedProject.value?.default_dashboard) {
    case 'self_perform':
      return SelfPerformDashboard;

    case 'head_contract':
      return HeadContractDashboard;

    default:
      return undefined;
  }
});
</script>

<style scoped></style>
